import { GetStaticPropsContext, InferGetStaticPropsType, NextPage } from 'next';

import { extractHeadings } from 'utils/structured-text.utils';

import { Duration } from 'constants/duration.constants';
import { NOT_FOUND } from 'constants/nextjs.constants';
import { termsOfServiceQuery } from 'queries/global/queries';
import Prefetcher from 'services/prefetcher';

import CustomPageTextContainer from 'components/@custom-pages/CustomPageTextContainer';
import AppNavigation from 'components/@navigation/AppNavigation';
import PageSeo from 'components/@seo/PageSeo';

const TermsOfService: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ seoTags, title, body, updatedAt, headings }) => {
  return (
    <AppNavigation>
      <PageSeo tags={seoTags} />
      <CustomPageTextContainer
        title={title}
        body={body}
        updatedAt={updatedAt}
        headings={headings}
      />
    </AppNavigation>
  );
};

export default TermsOfService;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });

  const { pageTermsOfService } = await prefetcher.prefetch(termsOfServiceQuery);

  if (!pageTermsOfService) return { ...NOT_FOUND };

  return {
    props: {
      seoTags: pageTermsOfService.seoTags,
      title: pageTermsOfService.title,
      body: pageTermsOfService.body,
      updatedAt: pageTermsOfService.updatedAt,
      headings: extractHeadings(pageTermsOfService.body),
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
};
